import { defineStore } from 'pinia';

import { fetchWrapper } from '@/helpers/fetch-wrapper';


const baseUrl = `${process.env.VUE_APP_API_URL}/auth`;

export const useAccountsStore = defineStore({
    id: 'accounts',
    state: () => ({
        accounts: []
    }),
    actions: {
        async fetchAll() {
            const response = await fetchWrapper.get(`${baseUrl}/accounts`);
            this.accounts = response.data;
        },
    }
});
